import { IIntegrationStore } from './index'

export default {
  settings: null,
  user: null,
  mapping: null,
  rooms: null,
  step: 0,
  changed: false,
  bookingError: [],
  troubledRooms: [],
  pricingInfo: 0,
  tab: 0,
  bookingObjects: [],
  loading: false,
  isTaken: false,
  propertyCheckLoading: false,
} as IIntegrationStore
